// extracted by mini-css-extract-plugin
export default {"wrapper":"l55M9","container":"slI1y","content":"cjC3Z","promocodeWrapper":"RyYyd","icon":"EkUCE","primary":"KtSba","copied":"Ao26Q","secondary":"KcAsG"};